import { AccountTypeEnum } from "@api";
import { Account } from "@rentablo/api/apiv1";
import i18n from "@translations/i18n";
import { DropdownSectionData } from "./DropdownWithSections/types";

const SORT_ORDER: Record<string, number> = {
  "01_depot": 0,
  "02_cash": 1,
};

export const groupDepots = (sourceData: Account[]): DropdownSectionData[] => {
  const groupsMap = new Map<
    AccountTypeEnum,
    Array<{ label: string; value: number }>
  >();

  sourceData.forEach((item) => {
    const type = item.type || "01_depot";

    if (!groupsMap.has(type)) {
      groupsMap.set(type, []);
    }

    groupsMap.get(type)!.push({
      label: item.name,
      value: item.id,
    });
  });

  return Array.from(groupsMap.entries())
    .map(([type, options]) => ({
      label: i18n.exists(`components.depotSelect.types.${type}`)
        ? i18n.t(`components.depotSelect.types.${type}`)
        : type.toUpperCase(),
      testId: type,
      options,
      type,
    }))
    .sort((a, b) => (SORT_ORDER[a.type] ?? 2) - (SORT_ORDER[b.type] ?? 2));
};
